import React, {
  FunctionComponent,
  memo,
  useMemo,
  useState,
  useEffect,
} from 'react';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { useGrowthDetails } from '../hooks';
import { getLocale, useParams, history } from 'umi';
import Loading from '@/pages/intelligence/components/Loading';
// import DetailBar from '../../../MobileDevice/Overview/MapBarChart';
import NewDetailBar from '../../components/NewDetailBar';
import { formatGrowthDetails, marketSizeTitleListSets } from '../utils';
import {
  getPositiveOrMixedType,
  calculateConstants,
  getBarWidth,
} from '@/pages/intelligence/utils/commonUtils';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { getCountryNameByCountryCode } from '@/pages/intelligence/utils/commonUtils';
import NoData from '@/pages/intelligence/components/NoData';

interface MarkDetaulsBottomProps {
  changeValue: string;
  type: boolean;
  newzooTitle: { [key in string]: unknown } | undefined;
  [key: string]: unknown;
}

const MarkDetaulsBottom: FunctionComponent<MarkDetaulsBottomProps> = ({
  changeValue,
  type,
  newzooTitle,
}) => {
  //增加纯国家列表以用来简称匹配全称用
  const [regionsCountries, setRegionsCountries] = useState<any>([]);
  //获取全局国家地区数据
  const { regionOptions } = useMarketFilterApi({ filterType: 'rpd' }); //RPD数据比较多，暂时用RPD返回的

  useEffect(() => {
    setRegionsCountries(regionOptions);
  }, [regionOptions]);

  const active = useParams() as any;
  const locale = getLocale();
  // Market Details数据,通过上下文catch Key 多次并发合将会并成一次请求
  const { data: marketData, loading: marketLoading } = useGrowthDetails(
    useMemo(
      () =>
        type
          ? {
              total_date: (+changeValue).toString(),
              start_date: (+changeValue - 1).toString(),
              end_date: (+changeValue).toString(),
            }
          : { total_date: (+changeValue).toString() },
      [changeValue, type],
    ),
    changeValue,
  );
  /*
    // 右下侧数据格式化
    const growthDetailsList = useMemo(() => {
      const res = marketData?.type_list.filter((ix: { type: string }) => {
        if (!type) {
          return ['Players+ & Payers+', 'Players+ & Payers-'].includes(ix.type);
        }
        return ix;
      });
      return formatGrowthDetails(res, active.tab, formatMessage);
    }, [active.tab, formatMessage, marketData?.type_list, type]);
   */
  const showBarNumb = 5;

  // 计算每个类型的分组数据
  const calculateTitleListData = (params: {
    titleList: any[];
    data: any[];
    listKey: string;
    leftValueKey: string;
    rightValueKey: string;
    textFomat1: Function;
    textFomat2: Function;
  }) => {
    const {
      titleList,
      data,
      listKey,
      leftValueKey,
      rightValueKey,
      textFomat1,
      textFomat2,
    } = params;
    if (!Array.isArray(titleList) || !Array.isArray(data)) {
      return [];
    }
    const barType = getPositiveOrMixedType({
      data,
      typeKey: listKey,
      calacuKey: rightValueKey,
    });
    return titleList.map((item) => {
      const targetGroup = data?.find((group) => group?.type === item.type);
      if (!Array.isArray(targetGroup?.[listKey])) {
        return {};
      }
      // 对第一份数据进行计算
      let { maxVal1, maxVal2Abs } = calculateConstants({
        data,
        typeKey: listKey,
        calacuKey1: leftValueKey,
        calacuKey2: rightValueKey,
        cacalMax: showBarNumb,
      });

      let list = [];
      for (let i = 0; i < showBarNumb; i++) {
        const target = targetGroup?.[listKey]?.[i];
        if (target) {
          const isPositive = Number(target[rightValueKey]) >= 0;
          const rightPositive = {
            text: textFomat2(target[rightValueKey]),
            width: maxVal2Abs
              ? getBarWidth(target[rightValueKey], maxVal2Abs)
              : 0,
            color: isPositive ? item.colorPositive :item.colorNegative,
          };
          list[i] = {
            name: regionsCountries?.length
              ? getCountryNameByCountryCode(
                  regionsCountries,
                  target?.country_abbre,
                )
              : target?.country,
            name_abbr: target?.country_abbre,
            barLeft: {
              text: textFomat1(target[leftValueKey]),
              width: maxVal1 ? getBarWidth(target[leftValueKey], maxVal1) : 0,
              color: item.colorPositive,
            },
            barRightPositive: isPositive ? rightPositive : {},
            barRightNegative: !isPositive ? rightPositive : {},
          };
        } else {
          if(type){
            //by player不添加空元素，用于页面自适应高度
            list[i] = {};
          }
        }
      }
      return {
        ...item,
        title: locale === LANGUAGE_CN ? item?.title_cn : item?.title,
        headerList:
          locale === LANGUAGE_CN
            ? item?.headerList_cn ?? item?.headerList
            : item?.headerList,
        barType: barType,
        list: list,
        titleTip:
          locale === LANGUAGE_CN
            ? item?.iconTip_cn || item?.iconTip
            : item?.iconTip,
      };
    });
  };

  const dataList = useMemo(() => {
    const currentTitleListSet = marketSizeTitleListSets[type ? 0 : 1];
    const data = marketData?.type_list || [];
    if (!Array.isArray(data) || !data?.length) {
      return [];
    }
    return calculateTitleListData({
      titleList: currentTitleListSet.titles,
      data: data,
      listKey: currentTitleListSet.listKey,
      leftValueKey: currentTitleListSet.leftValueKey,
      rightValueKey: currentTitleListSet.rightValueKey,
      textFomat1: currentTitleListSet.textFomat1,
      textFomat2: currentTitleListSet.textFomat2,
    });
  }, [active.tab, locale, marketData?.type_list, type]);

  return (
    <CardSlot
      className="dbi-global-view-revenue-growth"
      title={`${changeValue} ${newzooTitle?.bottomRight}`}
      isAction={false}
      isEyes={false}
      iconList={[]}
    >
      {marketLoading ? (
        <div style={{ height: '500px' }}>
          <Loading />
        </div>
      ) :
      !dataList?.length ?
        <NoData /> : (
        <div className={`${type ? 'dbi-revenue-flex' : 'dbi-players-flex'}`}>
          {/* {growthDetailsList.map((item, index) => (
                        <DetailBar
                            data={item.dataBody}
                            options={{
                                leftTitle: item?.dataHeader?.[0],
                                centerTitle: item?.dataHeader?.[1],
                                rightTitle: item?.dataHeader?.[2],
                            }}
                            tierColor={item.color as unknown as Array<string[]>}
                            key={index}
                            title={item.title}
                        />
                    ))} */}
          {dataList?.map((item, index) => {
            return <NewDetailBar key={index} data={item} 
              clickName={(t) => {
                history.push({
                  pathname: '/intelligence/MarketProfile/Overview/detail',
                  query: {
                    pageid: 'MarketProfilMobile',
                    marketName: t?.name || '',
                    marketNameEn: t?.name_abbr?.toLowerCase() || '',
                    fromPage: 'GlobalView',
                  },
                });
              }}
            />;
          })}
        </div>
      )}
    </CardSlot>
  );
};

export default memo(MarkDetaulsBottom);
